import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import { TabTableContainer } from 'components/layout/AppLayout/AppLayout.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import useRouterFilters from 'hooks/useRouterFilters';

import { SHIPPING_PRICES } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

/**
 * @author @muhammedburakak
 */

const NewRecordList = () => {
	const defaultSort = useMemo(() => [{ id: 'id', desc: true }], []);

	const columns = useMemo(
		() => [
			{
				Header: 'ID',
				accessor: 'id',
				filterType: FilterType.number,
				width: 70,
				show: false,
				showCopyButton: true
			},
			{ Header: 'otoOrderID', accessor: 'otoOrderID', filterType: FilterType.number, showCopyButton: true },
			{ Header: 'orderID', accessor: 'orderID', filterType: FilterType.string, showCopyButton: true },
			{
				Header: 'customerName',
				accessor: 'customerName',
				filterType: FilterType.string,

				showOnMobile: true
			},
			{
				Header: 'orderCreateDate',
				accessor: 'orderCreateDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'shipmentID',
				accessor: 'shipmentID',
				filterType: FilterType.string,
				showCopyButton: true
			},
			{
				Header: 'serviceType',
				accessor: 'serviceType',
				filterType: FilterType.multiSelection
			},
			{
				Header: 'deliveryName',
				accessor: 'deliveryCompanyName',
				filterType: FilterType.multiSelection
			},
			{
				Header: 'DCSettingID',
				accessor: 'DCSettingID',
				filterType: FilterType.number
			},
			{
				Header: 'lastShipmentStatus',
				accessor: 'lastShipmentStatus',
				filterType: FilterType.multiSelection,
				renderCell: ListComponents.STATUS
			},
			{
				Header: 'areaName',
				accessor: 'areaName',
				filterType: FilterType.string,
				width: 50,
				show: false
			},
			{
				Header: 'destinationCity',
				accessor: 'destinationCity',
				filterType: FilterType.string,
				width: 50
			},
			{ Header: 'originTier', accessor: 'originTier', filterType: FilterType.string },
			{
				Header: 'destinationTier',
				accessor: 'destinationTier',
				filterType: FilterType.string
			},
			{ Header: 'orderWeight', accessor: 'orderWeight', filterType: FilterType.float },
			{
				Header: 'shipmentChargingStatus',
				accessor: 'shipmentChargingStatus',
				filterType: FilterType.multiSelection
			},
			{
				Header: 'shipmentChargingDate',
				accessor: 'shipmentChargingDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'shipmentCreatedDate',
				accessor: 'shipmentCreatedDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'deliveredDate',
				accessor: 'deliveredDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'recordType',
				accessor: 'recordType',
				filterType: FilterType.multiSelection
			},
			{
				Header: 'recordDate',
				accessor: 'recordDate',
				filterType: FilterType.date,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'recordDescription',
				accessor: 'recordDescription',
				filterType: FilterType.string,
				width: 150
			},
			{
				Header: 'basePrice',
				accessor: 'basePrice',
				filterType: FilterType.float,
				renderCell: ListComponents.CURRENCY
			},
			{
				Header: 'returnFee',
				accessor: 'returnFee',
				filterType: FilterType.float,
				renderCell: ListComponents.CURRENCY
			},
			{
				Header: 'codFee',
				accessor: 'codFee',
				filterType: FilterType.float,
				renderCell: ListComponents.CURRENCY
			},
			{
				Header: 'extraKMFee',
				accessor: 'extraKMFee',
				filterType: FilterType.float,
				renderCell: ListComponents.CURRENCY
			},
			{
				Header: 'extraKGFee',
				accessor: 'extraKGFee',
				filterType: FilterType.float,
				renderCell: ListComponents.CURRENCY
			},
			{
				Header: 'insuranceFee',
				accessor: 'insuranceFee',
				filterType: FilterType.float,
				renderCell: ListComponents.CURRENCY
			},
			{
				Header: 'discountAmount',
				accessor: 'discountAmount',
				filterType: FilterType.float,
				renderCell: ListComponents.CURRENCY
			},
			{
				Header: 'priceToBeCharged',
				accessor: 'priceToBeCharged',
				filterType: FilterType.float,
				renderCell: ListComponents.CURRENCY
			},

			{
				Header: 'cutbackAmount',
				accessor: 'cutbackAmount',
				filterType: FilterType.float,
				renderCell: ListComponents.CURRENCY
			},
			{
				Header: 'extraCharge',
				accessor: 'extraCharge',
				filterType: FilterType.float,
				showOnMobile: true,
				renderCell: ListComponents.CURRENCY
			},
			{
				Header: 'invoicePeriod',
				accessor: 'invoicePeriod',
				filterType: FilterType.string,
				width: 120
			},
			{ Header: 'invoiceID', accessor: 'invoiceID', filterType: FilterType.number, showCopyButton: true },
			{
				Header: 'invoiceStatus',
				accessor: 'invoiceStatus',
				filterType: FilterType.multiSelection,
				showOnMobile: true,
				width: 120,
				renderCell: ListComponents.STATUS
			}
		],

		[]
	);

	const filtersFromRouter = useRouterFilters(columns);

	return (
		<TabTableContainer>
			<DynamicList
				id={DYNAMICLISTS.NEW_RECORDS}
				columns={columns}
				fetchUrl={SHIPPING_PRICES.GET_INVOICE_TRANSACTIONS_LIST}
				defaultFilters={filtersFromRouter}
				defaultSort={defaultSort}
				actionObjectType={ACTION_OBJECT_TYPES.OTHER}
				exportName="newRecords"
			/>
		</TabTableContainer>
	);
};

export default NewRecordList;
